import axios from "axios";
import jwt_decode from "jwt-decode";
import { API, APIPermisos } from "../Constants/ApiConnection";

export const checkPermisosPorUsuarioPorGuidPantalla = async (
  user,
  guidvista
) => {
  var { id } = jwt_decode(user.accessToken);
  let url = APIPermisos + `permission/checkPermisos/${id}/${guidvista}`;

  try {
    const response = await axios.get(url, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        "Access-Control-Allow-Headers": "*",
        "x-access-token": user.accessToken,
        maxBodyLength: Infinity,
      },
    });

    if (response.status === 200) {
      return response;
    }
  } catch (error) {
    console.error(error);
    return error;
  }
};
export const checkPermisosMenuPorUsuarioPorGuidPantalla = async (user) => {
  var { id } = jwt_decode(user.accessToken);
  let url = APIPermisos + `permission/checkMenu/${id}`;

  try {
    const response = await axios.get(url, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        "Access-Control-Allow-Headers": "*",
        "x-access-token": user.accessToken,
        maxBodyLength: Infinity,
      },
    });

    if (response.status === 200) {
      return response;
    }
  } catch (error) {
    console.error(error);
    return error.response;
  }
};

export const checkPermisosAEditarPorUsuario = async (user, idusuario) => {
  
  var { id } = jwt_decode(user.accessToken);
  let url = APIPermisos + `permission/getPermisosUsuario/${idusuario}`;

  try {
    const response = await axios.get(url, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        "Access-Control-Allow-Headers": "*",
        "x-access-token": user.accessToken,
        maxBodyLength: Infinity,
      },
    });

    if (response.status === 200) {
      return response;
    }
  } catch (error) {
    console.error(error);
    return error;
  }
};
export const setUnsetPermisoVistaUsuario = async (
  user,
  idUsuario,
  guidvista
) => {
  var { id } = jwt_decode(user.accessToken);
  let url = APIPermisos + `permission/setPermisoVistaUsuario/${idUsuario}/${guidvista}`;

  try {
    const response = await axios.put(
      url,
      {},
      {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          "Access-Control-Allow-Headers": "*",
          "x-access-token": user.accessToken,
          maxBodyLength: Infinity,
        },
      }
    );

    if (response.status === 200) {
      return response;
    }
  } catch (error) {
    console.error(error);
    return error;
  }
};
export const setUnsetPermisoFuncionUsuario = async (
  user,
  idUsuario,
  guidvista
) => {
  var { id } = jwt_decode(user.accessToken);
  let url =
    APIPermisos + `permission/setPermisoFuncionUsuario/${idUsuario}/${guidvista}`;

  try {
    const response = await axios.put(
      url,
      {},
      {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          "Access-Control-Allow-Headers": "*",
          "x-access-token": user.accessToken,
          maxBodyLength: Infinity,
        },
      }
    );

    if (response.status === 200) {
      return response;
    }
  } catch (error) {
    console.error(error);
    return error;
  }
};

export const obtenerPermisosPorUsuario = async (user, idusuario) => {
  
  var { id } = jwt_decode(user.accessToken);
  let url = APIPermisos + `permission/getPermisosUsuario/${idusuario}`;

  try {
    const response = await axios.get(url, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        "Access-Control-Allow-Headers": "*",
        "x-access-token": user.accessToken,
        maxBodyLength: Infinity,
      },
    });

    if (response.status === 200) {
      return response;
    }
  } catch (error) {
    console.error(error);
    return error;
  }
};
